module.exports = __webpack_public_path__ + "media/images/flags/32/Suriname-b97f5dfdb0580207d3c758c457d9a046.png";